<template>

<div>

    
    <div class="list-loader-outer">
        <transition name="loader-fade">
            <div class="list-loader" v-if="loading">
                <div class="loader"></div>
            </div>
        </transition>
    </div>

    <h1>Adresser 
        <a href="/addresses/new" class="btn btn-default btn-sm">
          Lägg till
        </a>
    </h1>

    <div class="searchbar">

        <form>

                <div class="block freetext" v-bind:class="{ active: search.text != '' && search.text != null }">
                    
                    <input class="form-control" v-on:keyup="updateQuery()" v-model="search.text" placeholder="Sök på titel, gata, postort, stadsdel och postnummer" />

                </div>

                <a data-toggle="modal" data-target="#myModal" class="btn btn-sm btn-default pull-right">
                    <i class="fa fa-file" aria-hidden="true"></i> Spara excel</i>
                </a>

                <a class="btn btn-sm btn-default pull-right" v-on:click="exportBenify()">
                    <i class="fa fa-file" aria-hidden="true"></i> Exportera till Benify</i>
                </a>
            
    <br clear="all">

        </form>

    </div>

</div>


</template>


<script>

    export default {
        props: {
            query: {
                required: true
            },
            loading: {}
        },
        data: function () {
            return {
                search: {}
            }
        },
        methods: {

            updateQuery: function() {

                this.$emit('search', this.search);

            },


            exportBenify() {

                var self = this

                if(confirm("Är du säker?")) {

                    window.open('/addresses/exportBenify');

                }

            }
        },
        watch: {
            query: function() {

                this.search = this.query;

            }
        }
    }

</script>